import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content p-0" }
const _hoisted_2 = { class: "container-fluid" }

import SignIn from "../../components/Authentication/SignIn/SignIn.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'SignInPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SignIn)
    ])
  ]))
}
}

})